export default "__VITE_ASSET__CNA51bpf__"